import { render, staticRenderFns } from "./FilterOrderCount.vue?vue&type=template&id=bc272048&lang=pug&"
import script from "./FilterOrderCount.vue?vue&type=script&lang=js&"
export * from "./FilterOrderCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports